// extracted by mini-css-extract-plugin
export default {"container":"_404_container__qRjNb","title":"_404_title__WZZdc","message":"_404_message__KVQI1","button":"_404_button__LlgR0"};